import { render, staticRenderFns } from "./EcosystemsAccessSettings.vue?vue&type=template&id=46cc2d46&scoped=true&"
import script from "./EcosystemsAccessSettings.vue?vue&type=script&lang=js&"
export * from "./EcosystemsAccessSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cc2d46",
  null
  
)

export default component.exports